import React,{useState,useEffect} from 'react'
import ClinicCard from './modules/ClinicCard'
import PatientCard from './modules/PatientCard'
import dashboardService from '../../services/dashboard.service'

function Dashboard() {
  const [stats,setStats] = useState()

  useEffect(()=>{
    dashboardService.getStats()
    .then(res=>{
      setStats(res.data)
    })
    .catch(err=>{
      console.log("Error")
      console.log(err)
    })
  },[])
  
  function toProperCase(inputString) {
    // Split the string into words based on underscores
    let words = inputString.split('_');
  
    // Capitalize the first letter of each word and join them back
    let properCaseString = words.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
  
    return properCaseString;
  }
  return (
    <>
      <div className="container">
        <div style={{height:"150px"}} className='bg-primary rounded-2'>
        </div>
        <div className="row" style={{marginTop:"-4rem"}}>
          <div className="col-8 offset-2">
             {stats && <>
                <div className="card rounded ms-3">
                  <div className="card-body rounded-pill mt-3">
                      <table className="table table-striped ">
                        <tbody>
                            {stats.map((item,index)=>{
                               return(<tr key ={index}>
                                    <td>{toProperCase(item.name)}</td>
                                    <td>{item.value}</td>
                               </tr>  )
                            })}
                        </tbody>
                      </table>
                  </div>
                </div>
             
             </>}
          </div>
          
        </div>
      </div>
    </>
  )
}

export default Dashboard